module.exports = __webpack_public_path__ + "img/5_cover2.161372b3.png";